"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { useTranslation } from "react-i18next";
import { resolveLangFromPathname } from "@/utils/library/languages";

export function LanguageSetter({
  children,
}: Readonly<{ children: React.ReactNode }>) {
  const { i18n } = useTranslation();
  const pathname = usePathname();
  const lang = resolveLangFromPathname(pathname);

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  if (i18n.language !== lang) {
    i18n.changeLanguage(lang);
  }

  return <>{children}</>;
}
